import { useEffect, useState } from 'react';
import { objectsForEach } from '../../../../common/objectToArray';
import Select from '../../../../components/Common/Input/Select';
import GraphContainer from '../../../../components/Portfolio/GraphContainer';
import { bg } from '../../../../constant/options';
import LenderUgroService from '../../../../services/lender';
import MasterDataService from '../../../../services/master-data';
import GraphTypeFilter from '../GraphTypeFilter';

function UnassignedLeads({ userType }) {
	const [loading, setLoading] = useState(true);
	const [queryParams, setQueryParams] = useState({});
	const [error, setError] = useState(false);
	const [series, setSeries] = useState([]);
	const [options, setOptions] = useState({
		chart: {
			type: 'bar',
			height: 430,
		},
		plotOptions: {
			bar: {
				dataLabels: {
					position: 'top',
				},
			},
		},
		dataLabels: {
			enabled: true,
			offsetY: -20,
			style: {
				fontSize: '12px',
				colors: ['#5A5B79'],
			},
		},
		stroke: {
			show: true,
			width: 1,
			colors: ['#fff'],
		},
		tooltip: {
			shared: true,
			intersect: false,
		},
		colors: [bg[1].color],
	});
	const getDashboardUnassignedLeads = async () => {
		setLoading(true);
		setError(false);
		try {
			const response = await LenderUgroService.dashboardUnassignedPortfolio({
				type: userType,
				params: queryParams,
				subType: userType == 'admin' ? 'co-lender' : '',
			});
			if (response?.data?.status?.code === 1) {
				const categories = response?.data?.data?.x?.lead_type;

				setOptions((previous) => {
					return {
						...previous,
						xaxis: {
							categories: categories,
						},
					};
				});
				let seriesData = [
					{
						name: 'No. of leads',
						data: response?.data?.data?.y?.count,
					},
				];
				setSeries(seriesData);
			}
		} catch (err) {
			setError();
			console.log(err);
		}
		setLoading(false);
	};

	useEffect(() => {
		getDashboardUnassignedLeads();
	}, [queryParams]);
	return (
		<GraphContainer
			filters={<Filters userType={userType} setQueryParams={setQueryParams} />}
			options={options}
			loading={loading}
			title={'Unassigned Leads'}
			series={series}
			type={'bar'}
			error={error}
			height={200}
		/>
	);
}
const Filters = ({ userType, setQueryParams }) => {
	const [productNames, setProducts] = useState([]);
	const [productName, setProductName] = useState([]);
	const [leadType, setLeadType] = useState();
	const [graphType, setGraphType] = useState();
	const productList = async () => {
		const response = await MasterDataService.getProductTypeList(
			userType,
			userType === 'admin' ? 'co-lender' : ''
		);
		if (response?.data?.status?.code === 1) {
			let responseList = objectsForEach(
				response.data.data.product_category,
				'STRING_VAL'
			);
			let products = responseList.map((response) => ({
				label: response.value,
				value: response.id,
			}));
			setProducts(products);
		}
	};
	useEffect(() => {
		productList();
	}, []);
	useEffect(() => {
		if (productName || leadType) {
			setQueryParams({
				lead_type: leadType?.value || '',
				prod_cat: productName.map((productName) => productName.value) || '',
				graph_type: graphType?.value || '',
			});
		}
	}, [productName, leadType, graphType]);
	return (
		<div className='row mt-2'>
			<div className='col-md-4'>
				<Select
					label='Program Name'
					options={productNames}
					onChange={(data) => setProductName(data)}
				/>
			</div>
			<div className='col-md-4 px-0'>
				<Select
					isMulti={false}
					label='Co-lending Type'
					options={[
						{ label: 'Option 1', value: 1 },
						// { label: 'Option 1 PS', value: 3 },
						{ label: 'Option 2', value: 2 },
					]}
					value={leadType}
					onChange={(data) => setLeadType(data)}
				/>
			</div>
			<div className='col-md-4'>
				<GraphTypeFilter onGraphTypeChange={(value) => setGraphType(value)} />
			</div>
		</div>
	);
};
export default UnassignedLeads;
